import { HTTP_CONFIG } from "../http-configs/http.config";
import { LOCALES } from "./locales.config";
import { CollectingStrategy, TranslateConfig } from "@ogs-gmbh/ngx-translate";
import { SKIP_KEYCLOAK_INTERCEPTOR } from "@ogs/ngx-keycloak";
import { mergeHttpConfig } from "@ogs-gmbh/ngx-http";
import { HttpHeaders } from "@angular/common/http";


const translationHeader: HttpHeaders = new HttpHeaders()
  .append(SKIP_KEYCLOAK_INTERCEPTOR, "true");

export const TRANSLATE_CONFIG: TranslateConfig = {
  translate: {
    timeout: 200_000,
    fallbackToSourceLocale: false,
    locales: LOCALES,
    defaultScope: "global",
    storageConfig: {
      collectingStrategy: CollectingStrategy.ALL,
      locale: {
        store: true
      },
      translations: {
        store: false
      }
    }
  },
  http: {
    config: mergeHttpConfig(
      HTTP_CONFIG,
      {
        path: "/api/translations"
      }
    ),
    options: { headers: translationHeader }
  }
};
